import React, { useState, useEffect, useRef } from "react";
import { FaPhone, FaWhatsapp, FaEnvelope, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./FloatingKontaktButton.css";

const FloatingKontaktButton = ({
  phoneNumber = "+4915756850714",
  message = "Hallo! Ich interessiere mich für Ihre Porsche-Werkstatt.",
  contactFormUrl = "/kontakt",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down more than 100px from top
      setIsVisible(window.scrollY > 100);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Initial check
    handleScroll();

    // Cleanup
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleButtonClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCall = () => {
    setIsMenuOpen(false);
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    setIsMenuOpen(false);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappLink, "_blank", "noopener,noreferrer");
  };

  const closeApplicationMenus = () => {
    // Close any open application menus by removing body classes
    document.body.classList.remove("no-scroll");
    document.body.classList.remove("full-menu-open");

    // Dispatch a custom event to notify menu components to close
    window.dispatchEvent(new CustomEvent("closeMenus"));
  };

  const handleContactForm = () => {
    // Close floating menu immediately
    setIsMenuOpen(false);
    // Close any open application menus
    closeApplicationMenus();
    // Navigate to contact page with hash
    navigate(contactFormUrl + "#contact-form");
  };

  return (
    <div
      className={`floating-kontakt-container ${
        isVisible ? "visible" : "hidden"
      }`}
    >
      {/* Context Menu */}
      {isMenuOpen && (
        <div ref={menuRef} className="kontakt-menu">
          <button
            className="kontakt-menu-item kontakt-menu-call"
            onClick={handleCall}
          >
            <FaPhone className="kontakt-menu-icon" />
            <span className="desktop-phone-number">{phoneNumber}</span>
            <span className="mobile-anrufen">Anrufen</span>
          </button>

          <button
            className="kontakt-menu-item kontakt-menu-whatsapp"
            onClick={handleWhatsApp}
          >
            <FaWhatsapp className="kontakt-menu-icon" />
            <span>WhatsApp</span>
          </button>

          <button
            className="kontakt-menu-item kontakt-menu-form"
            onClick={handleContactForm}
          >
            <FaEnvelope className="kontakt-menu-icon" />
            <span>Kontakt Formular</span>
          </button>
        </div>
      )}

      {/* Main Button */}
      <button
        ref={buttonRef}
        className={`floating-kontakt-button ${isMenuOpen ? "active" : ""}`}
        onClick={handleButtonClick}
        aria-label="Kontakt Optionen"
      >
        {isMenuOpen ? (
          <FaTimes className="kontakt-button-icon" />
        ) : (
          <span className="kontakt-button-text">Kontakt</span>
        )}
      </button>
    </div>
  );
};

export default FloatingKontaktButton;
